<template>
  <v-row>
    <v-col cols="12" sm="10" md="10" lg="8" class="mx-auto">
      <v-card rounded="lg">
        <v-container fluid class="py-0">
          <v-row>
            <v-col
              cols="5"
              class="pa-0 pr-0 d-none d-md-flex cabin-truck-image-wrapper"
            >
              <div class="cabin-truck-image"></div>
            </v-col>
            <v-col
              class="col-12 col-md-7 py-11 py-md-14 py-lg-9 py-xl-14 px-11 px-xl-16"
            >
              <div class="d-flex flex-column text-center card-container">
                <h1
                  class="secondary--text font-weight-black d-flex mx-auto text-xs-h4"
                >
                  {{ $t('portal.register.create_password.labels.title') }}
                </h1>
                <p
                  class="secondary--text d-flex mx-auto mb-0 font-weight-normal text-h6"
                >
                  {{
                    $t('portal.register.create_password.labels.label_register')
                  }}
                </p>
                <v-stepper alt-labels id="stepper">
                  <v-stepper-header>
                    <v-divider class="divider"></v-divider>
                    <v-stepper-step step="1">
                      <p
                        class="text-center primary--text font-weight-black text-h6 mb-0"
                      >
                        {{
                          $t(
                            'portal.register.create_password.labels.label_step_one'
                          )
                        }}
                      </p>
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="2">
                      <p
                        class="text-center light-grey font-weight-black text-h6 mb-0"
                      >
                        {{
                          $t(
                            'portal.register.create_password.labels.label_step_two'
                          )
                        }}
                      </p>
                    </v-stepper-step>
                    <v-divider></v-divider>
                  </v-stepper-header>
                </v-stepper>

                <div v-if="!codeExpired">
                  <div class="password--info">
                    <p class="secondary--text mb-0 text-center">
                      {{
                        $t(
                          'portal.register.create_password.labels.label_enter_password'
                        )
                      }}
                    </p>
                    <span class="text-body-2 text-center text-sm-start">{{
                      $t(
                        'portal.register.create_password.labels.label_password_structure'
                      )
                    }}</span>
                  </div>

                  <v-form
                    ref="pwdForm"
                    @submit.prevent
                    lazy-validation
                    class="d-flex flex-column form-container mt-4"
                  >
                    <label
                      class="text-subtitle-2 text-start deepSkyBlue--text mt-xl-3"
                      >{{
                        $t(
                          'portal.register.create_password.labels.label_password'
                        )
                      }}</label
                    >
                    <v-text-field
                      color="deepSkyBlue"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword ? 'text' : 'password'"
                      v-model="password"
                      :rules="[rules.required, rules.format, rules.valid]"
                      dense
                      filled
                      required
                      class="text-field my-xl-2"
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                    <label
                      class="text-subtitle-2 text-start deepSkyBlue--text"
                      >{{
                        $t(
                          'portal.register.create_password.labels.label_confirm_password'
                        )
                      }}</label
                    >
                    <v-text-field
                      color="deepSkyBlue"
                      :append-icon="
                        showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
                      "
                      :type="showConfirmPassword ? 'text' : 'password'"
                      v-model="confirm_password"
                      dense
                      :rules="[
                        rules.required,
                        rules.confirm,
                        rules.format,
                        rules.valid
                      ]"
                      filled
                      class="text-field my-xl-2"
                      required
                      @keyup.enter="submit"
                      @click:append="showConfirmPassword = !showConfirmPassword"
                    ></v-text-field>
                  </v-form>
                </div>
                <v-alert
                  v-model="alert"
                  dark
                  transition="fade-transition"
                  color="primary"
                  class="text-start mb-6"
                >
                  <div class="white--text font-weight-bold mb-0">
                    {{ $t('portal.register.create_password.alerts.warning') }}
                  </div>
                  <div class="white--text mb-0">
                    {{ alertMessage }}
                  </div>
                </v-alert>

                <v-btn
                  v-if="codeExpired"
                  color="secondary"
                  rounded
                  outlined
                  @click="welcomeMail"
                  class="mt-5"
                  style="height: 48px"
                  >{{
                    $t('portal.register.create_password.labels.label_send_mail')
                  }}</v-btn
                >
                <div
                  class="d-inline-flex justify-end align-items-center mt-xl-2 mt-md-0"
                >
                  <v-btn
                    v-if="!codeExpired"
                    rounded
                    justify="end"
                    color="deepSkyBlue"
                    :disabled="!btnDisabled"
                    :loading="loading"
                    @click="submit"
                    class="white--text"
                    >{{
                      $t('portal.register.create_password.labels.submit_button')
                    }}</v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { magentaOAuth } from '@leapsight/styleguide'
import i18n from '@/plugins/i18n'

export default {
  name: 'CreatePassword',
  props: {},
  data() {
    return {
      loading: false,
      userIsAdmin: false,
      termsAccepted: false,
      showPassword: false,
      showConfirmPassword: false,
      termsModal: false,
      alert: false,
      alertMessage: '',
      password: '',
      confirm_password: '',
      username: '',
      passwordCode: '',
      codeExpired: false,
      user_id: '',
      rules: {
        required: value =>
          !!value ||
          i18n.t('portal.register.create_password.rules.password_required'),
        confirm: v =>
          this.password === this.confirm_password ||
          i18n.t('portal.register.create_password.rules.password_match'),
        format: value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/
          return (
            pattern.test(value) ||
            i18n.t('portal.register.create_password.rules.password_structure')
          )
        },
        valid: value => {
          const pattern = /^(?=.*[0-9])[a-zA-Z0-9!"'()+,\\.\-/?@#\]\[$%^_`{}|~&*]{8,30}$/
          return (
            pattern.test(value) ||
            i18n.t('portal.register.create_password.rules.password_valid_chars')
          )
        }
      },
      invalidChars: []
    }
  },

  methods: {
    submit() {
      if (this.$refs.pwdForm.validate()) {
        this.loading = !this.loading
        const data = {
          username: this.$route.params.username,
          password_code: this.$route.params.password_code,
          user_id: this.$route.params.user_id,
          password: this.password
        }
        magentaOAuth
          .setPassword(data)
          .then(res => {
            if (res.status == 204) {
              this.loading = !this.loading
              this.$router.push({ name: 'set-password-succesfull' })
            } else {
              switch (res.data.code) {
                case 'com.magenta.error.user.signup_already_completed':
                  this.alertMessage = i18n.t(
                    'portal.register.create_password.errors.signup_completed'
                  )
                  this.alert = true
                  break

                case 'com.magenta.error.user.expired_password_code':
                  this.alertMessage = i18n.t(
                    'portal.register.create_password.errors.code_expired'
                  )
                  this.alert = true
                  this.codeExpired = true
                  break

                case 'com.magenta.error.user.invalid_password_code':
                  this.alertMessage = i18n.t(
                    'portal.register.create_password.errors.code_invalid'
                  )
                  this.alert = true
                  break

                case 'com.magenta.error.user.username_not_found':
                  this.alertMessage = i18n.t(
                    'portal.register.create_password.errors.user_not_found'
                  )
                  this.alert = true
                  break

                case 'com.magenta.error.person.not_found':
                  this.alertMessage = i18n.t(
                    'portal.register.create_password.errors.user_not_found'
                  )
                  this.alert = true
                  break

                case 'com.magenta.error.user.not_active':
                  this.alertMessage = i18n.t(
                    'portal.register.create_password.errors.user_not_active'
                  )
                  this.alert = true
                  break

                case 'com.magenta.error.user.invalid_set_password_state':
                  this.alertMessage = i18n.t(
                    'portal.register.create_password.errors.invalid_password_state'
                  )
                  this.alert = true
                  this.codeExpired = true
                  break

                default:
                  this.alertMessage = i18n.t(
                    'portal.register.create_password.errors.no_response'
                  )
                  this.alert = true

                  break
              }
              this.loading = !this.loading
            }
          })

          .catch(err => {
            this.alertMessage = i18n.t(
              'portal.register.create_password.errors.no_response'
            )
            this.loading = !this.loading
          })
      }
    },
    welcomeMail() {
      this.loading = !this.loading
      const data = {
        username: this.$route.params.username,
        user_id: this.$route.params.user_id
      }
      magentaOAuth
        .requestWelcomeMail(data)
        .then(res => {
          if (res.status == 204) {
            this.$router.push({ name: 'welcome-mail-resend' })
            this.loading = !this.loading
          } else {
            switch (res.data.code) {
              case 'com.magenta.error.user.signup_already_completed':
                this.alertMessage = i18n.t(
                  'portal.register.create_password.errors.signup_completed'
                )
                this.alert = true

                break

              case 'com.magenta.error.user.username_not_found':
                this.alertMessage = i18n.t(
                  'portal.register.create_password.errors.user_not_found'
                )
                this.alert = true

                break

              case 'com.magenta.error.person.not_found':
                this.alertMessage = i18n.t(
                  'portal.register.create_password.errors.user_not_found'
                )
                this.alert = true

                break
              case 'com.magenta.error.user.not_active':
                this.alertMessage = i18n.t(
                  'portal.register.create_password.errors.user_not_active'
                )
                this.alert = true
                break
              default:
                this.alertMessage = i18n.t(
                  'portal.register.create_password.errors.no_response'
                )
                this.alert = true
                break
            }
            this.loading = !this.loading
          }
        })
        .catch(err => {
          this.alertMessage = i18n.t(
            'portal.register.create_password.errors.no_response'
          )
          this.loading = !this.loading
        })
    }
  },
  computed: {
    btnDisabled: function() {
      if (this.password.length > 7 && this.confirm_password.length > 7) {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cabin-truck-image-wrapper {
  position: relative;
  .cabin-truck-image {
    background-image: url('../../assets/cabin-truck.png');
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    background-position: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
}

.password--info {
  p {
    font-size: 1.0625rem;
  }
  span {
    color: var(--brownish-grey);
  }
}
.light-grey {
  color: var(--light-grey-blue);
}
.divider {
  background-color: var(--dark-hot-pink);
  height: 3px;
  max-height: 3px;
}
</style>
